import React from 'react';
import styles from './RoutesPageSkeleton.module.css';

export default function RoutesPageSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.headerSkeleton}>
        <div className={styles.titleSkeleton} />
      </div>
      
      <div className={styles.filterSkeleton} />

      <div className={styles.grid}>
        {[1, 2, 3, 4, 5, 6].map(i => (
          <div key={i} className={styles.cardSkeleton} />
        ))}
      </div>
    </div>
  );
}
